
import CryptoJS from 'crypto-js';
const secretKey = '2424673890';

// Encrypt
export const encrypt = (value, key) => {
	const encryptedString = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
	localStorage.setItem(key, encryptedString);
}

// Decrypt
export const decrypt = (key) => {
	const decryptedString = localStorage.getItem(key);
	if (decryptedString) {
	    const bytes = CryptoJS.AES.decrypt(decryptedString, secretKey);
	    const decryptedInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	    return decryptedInfo;
	}
}